module.exports = __webpack_public_path__ + "img/cup3.c37835d1.png";